
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-summary");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/summary/index.js
// module id = 7LXi
// module chunks = 6